import QRCode from "qrcode";
import Modal from "ant-design-vue/lib/modal/Modal";
import message from "ant-design-vue/lib/message";
/**
 * 获取浏览器参数
 * @param {*} name 参数key
 * @returns 参数value
 */
export function getUrlParams(name) {
  var url = this.$router.history.current.fullPath;
  return new URLSearchParams(url).get(name);
}

/**
 * 分割数组为二维数组
 * @param {*} array 数组
 * @param {*} size 每一维几个元素
 * @returns 二维数组
 */
export function splitArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

/**
 * 生成二维码
 * @param {*} text
 * @returns
 */
export async function generateQR(text) {
  try {
    return await QRCode.toDataURL(text, {
      errorCorrectionLevel: "H",
      version: 2,
      margin: 2,
    });
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * url是否有效
 * @param {*} url
 * @returns
 */
export function validateURL(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * 加密身份证号
 */
export function encryptIdCard(idCard) {
  if (!idCard) return;
  if (!idCard || idCard.length != 18) return;
  return idCard.replace(/(.{6}).*(.{4}).*/, "$1****$2");
}

export function encryptPhone(phone) {
  if (phone.length != 11 || !validatePhoneNumber(phone)) return;
  return phone.replace(/(.{3}).*(.{4}).*/, "$1****$2");
}

export function getIdCardType(cardType, languagePreference = 1) {
  const cardTypeMap = {
    1: {
      zh: "大陆居民身份证",
      en: "People's Republic of China Resident Identity Card",
    },
    2: { zh: "外籍旅客护照", en: "Foreign Passenger Passport" },
    3: {
      zh: "台湾居民来往大陆通行证",
      en: "Mainland travel permit for Taiwan residents",
    },
    4: {
      zh: "港澳居民来往内地通行证",
      en: "Mainland Travel Permit for Hong Kong and Macao Residents",
    },
    5: {
      zh: "港澳同胞回乡证",
      en: "Home Return Certificate (for Compatriots from Hong Kong and Macao)",
    },
    6: {
      zh: "外国人永久居留身份证",
      en: "Foreign Permanent Resident ID Card",
    },
    7: { zh: "其他类型证件", en: "Other Types of Identification" },
  };

  if (cardType === undefined || !(cardType in cardTypeMap)) {
    return languagePreference === 4 ? "Unknown Identification" : "未知证件";
  }

  // 根据 languagePreference 决定返回的语言版本
  if (languagePreference === 4) {
    // 如果 languagePreference 是 4，则返回英文
    return cardTypeMap[cardType].en;
  } else if ([1, 2, 3].includes(languagePreference)) {
    // 如果 languagePreference 是 1, 2, 或 3 中的任意一个，则返回中文
    return cardTypeMap[cardType].zh;
  } else {
    // 默认情况返回中文
    return cardTypeMap[cardType].zh;
  }
}
// export function getIdCardType(cardType) {
//   if (cardType == 0) return "大陆居民身份证";
//   switch (cardType) {
//     case 0:
//       return "大陆居民身份证";
//     case 1:
//       return "外籍旅客护照";
//     case 2:
//       return "台湾居民来往大陆通行证";
//     case 3:
//       return "港澳居民来往内地通行证";
//     case 4:
//       return "港澳同胞回乡证";
//     case 5:
//       return "外国人永久居留身份证";
//     case 6:
//       return "其他类型证件";
//     default:
//       return "未知证件";
//   }
// }

/**
 * 验证身份证号码是否合法
 * @param {*} idCard
 * @returns
 */
export function isValidIdCard(idCard) {
  // 15位身份证号码正则表达式（全部为数字）
  var regIdCard15 =
    /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|1\d|2[0-9]|3[0-1])\d{3}$/;
  // 18位身份证号码正则表达式（数字和大写X）
  var regIdCard18 =
    /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|1\d|2[0-9]|3[0-1])\d{3}(\d|X|x)$/;

  // 使用test()方法测试字符串是否符合正则
  if (regIdCard15.test(idCard)) {
    // 15位身份证简单校验通过（没有校验码）
    return true;
  } else if (regIdCard18.test(idCard)) {
    // 18位身份证需要校验最后一位校验码
    var aCity = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外",
    };

    if (!aCity[parseInt(idCard.substr(0, 2))]) {
      return false; // 检查地区编码
    }

    // 权重因子
    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 校验码对应值
    var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];

    var sum = 0;
    var idCardWight = idCard.split("");
    // 从右至左开始计算
    for (var i = 0; i < 17; i++) {
      sum += parseInt(idCardWight[i]) * factor[i];
    }

    // 计算出的校验码与最后一位身份证号码校验码进行比较
    if (parity[sum % 11] == idCardWight[17].toUpperCase()) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
/**
 * 验证手机号码
 * @param {*} phoneNumber
 * @returns
 */
export function validatePhoneNumber(phoneNumber) {
  const regex = /^1[3-9]\d{9}$/;
  return regex.test(phoneNumber);
}

export function validateEmail(email) {
  const regex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
  return regex.test(email);
}

export function showModal(config) {
  Modal.confirm({
    centered: true,
    title: config.title || "提示",
    content: config.desc,
    okText: config.okText,
    cancelText: config.cancelText,
    onOk() {
      if (config.outside && !!config.outside) {
        if (!validateURL(config.outside)) {
          message.open({
            type: "error",
            duration: 2,
            maxCount: 3,
            content: "配置的链接解析错误",
          });
          return;
        }
        const dom = document.createElement("a");
        dom.href = config.outside;
        dom.target = config.target || "_self";
        dom.click();
      }
    },
  });
}

/**
 * 解析特殊异常信息
 * @param {} errorMessage
 * @returns
 */
export function parseErrorMessage(errorMessage, defaultResult = false) {
  const regex = /^\[(.*?)\]\s*(.*)$/;
  const matches = errorMessage.match(regex);

  if (matches) {
    // matches[1] 是捕获组1，对应于错误代码，例如 P1001
    // matches[2] 是捕获组2，对应于错误消息，例如 项目已过期！
    return {
      code: matches[1],
      message: matches[2].trim(), // 使用 trim() 去除可能存在的多余空格
    };
  } else {
    // 如果没有匹配成功，则返回 defaultResult
    return defaultResult;
  }
}
